/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to your ${i?.app_name} account`)
};

const zh_hans1_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登录您的 ${i?.app_name} 账户`)
};

const zh_hant1_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登入您的 ${i?.app_name} 帳戶`)
};

const fr_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connectez-vous à votre compte ${i?.app_name}`)
};

const de_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Melde dich bei deinem ${i?.app_name}-Konto an`)
};

const ja_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app_name} アカウントにサインイン`)
};

const ko_login_welcome_desc = /** @type {(inputs: { app_name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app_name} 계정에 로그인하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ app_name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_welcome_desc = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_welcome_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_welcome_desc", locale)
	if (locale === "en") return en_login_welcome_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_welcome_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_welcome_desc(inputs)
	if (locale === "fr") return fr_login_welcome_desc(inputs)
	if (locale === "de") return de_login_welcome_desc(inputs)
	if (locale === "ja") return ja_login_welcome_desc(inputs)
	return ko_login_welcome_desc(inputs)
};